import { Box } from '@mui/material';

import { MarketCardSkeleton } from '../../common/MarketCardSkeleton';

const SKELETON_ITEMS = [1, 2, 3, 4, 5, 6, 7, 8];

export const HomeMarketCardSkeleton = ({
  gridStyles,
}: {
  gridStyles:
    | string
    | {
        xs?: string;
        sm?: string;
        md?: string;
        lg?: string;
      };
}) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: gridStyles,
        gap: 1.5,
      }}
    >
      {SKELETON_ITEMS.map((item) => (
        <MarketCardSkeleton key={item} />
      ))}
    </Box>
  );
};
